import { render, staticRenderFns } from "./deforestedoilpalm-clusters-summary.vue?vue&type=template&id=fc14bbac&scoped=true&"
import script from "./deforestedoilpalm-clusters-summary.vue?vue&type=script&lang=js&"
export * from "./deforestedoilpalm-clusters-summary.vue?vue&type=script&lang=js&"
import style0 from "./deforestedoilpalm-clusters-summary.vue?vue&type=style&index=0&id=fc14bbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc14bbac",
  null
  
)

export default component.exports